import { render } from "./LetterboxdPage.vue?vue&type=template&id=7ee3616f&scoped=true"
import script from "./LetterboxdPage.vue?vue&type=script&lang=js"
export * from "./LetterboxdPage.vue?vue&type=script&lang=js"

import "./LetterboxdPage.vue?vue&type=style&index=0&id=7ee3616f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee3616f"]])

export default __exports__